import Vue from 'vue';
import { CalendarView } from 'vue-simple-calendar';
// import 'vue-simple-calendar/static/css/holidays-us.css'
import 'vue-simple-calendar/static/css/default.css';

var calendarview = {
    install: function install(Vue, options) {
        Vue.component('calendar-view', CalendarView);
    }
};

// const calendarviewhear = {
//     install(Vue, options) {
//         Vue.component('calendar-view-header', CalendarViewHeader);
//     }
// };

Vue.use(calendarview);
export default calendarview;
// Vue.use(calendarviewhear);


//////////////////
// WEBPACK FOOTER
// ./plugins/CalendarView.js
// module id = ./plugins/CalendarView.js
// module chunks = 20